import LegalContentRenderer from '../components/LegalContentRenderer';
import { aboutContent } from '../mock/legalContent';

const AboutUs = () => <LegalContentRenderer content={aboutContent} />;

export default AboutUs;
